<template>
  <div id="app">
    <!-- header -->
    <div class="header--block">
      <div class="major-menu">
        <div class="contacts-menu">
          <ul class="contacts-menu--list">
            <li class="contacts-menu--item">
              <a class="contacts-menu--item-link" href="tel:+370 5 264 4800" target="_self">
                <div class="contacts-menu--item-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    class
                  >
                    <path
                      transform="translate(-730 -1535)"
                      d="M739 1535a9 9 0 1 1 0 18.01 9 9 0 0 1 0-18.01zm0 16.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4zm3.73-5.32a.38.38 0 0 1 .26.34 1.6 1.6 0 0 1-.6 1.34l-.1.08-.05.04a.83.83 0 0 1-.07.06l-.07.04c-1.04.6-3-.1-4.72-1.7a7.92 7.92 0 0 1-.2-.2l-.04-.03-.04-.03-.2-.2c-1.59-1.72-2.28-3.69-1.69-4.72l.05-.08a.83.83 0 0 1 .05-.07l.04-.06.08-.1c.33-.4.83-.62 1.35-.58.09 0 .18.04.24.1l.09.15.13.38.5 1.47c.04.13.01.27-.08.37l-.43.5c-.1.1-.11.26-.05.38a4.99 4.99 0 0 0 2.45 2.47c.13.06.28.03.39-.06l.5-.44c.1-.09.24-.12.37-.07l1.47.5.37.13z"
                    ></path>
                  </svg>
                </div>
                <div class="contacts-menu--item-name">+370 5 264 4800</div>
              </a>
            </li>
            <li class="contacts-menu--item">
              <a
                class="contacts-menu--item-link"
                href="https://urbo.lt/en/contact-us"
                target="_blank"
              >
                <div class="contacts-menu--item-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                  >
                    <path
                      transform="translate(-731 -21)"
                      d="M739.99 21a9 9 0 1 1 .01 18 9 9 0 0 1-.01-18zm.01 16.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4zm3.2-10.2c.44 0 .8.34.8.75v4.5c0 .41-.36.75-.8.75h-6.4c-.44 0-.8-.34-.8-.75v-4.5c0-.41.36-.75.8-.75zm0 1.5v-.75l-3.2 1.88-3.2-1.88v.75l3.2 1.88z"
                    ></path>
                  </svg>
                </div>
                <div class="contacts-menu--item-name">Contact us</div>
              </a>
            </li>
            <li class="contacts-menu--item">
              <div
                class="contacts-menu--item-close-hover"
                id="contacts-close"
                contacts-trigger="contacts-menu"
              ></div>
              <div class="contacts-menu--item-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  class
                >
                  <path
                    transform="translate(-1298 -24)"
                    id="close"
                    d="M1310 25.21l-1.21-1.21-4.79 4.79-4.79-4.79-1.21 1.21 4.79 4.79-4.79 4.79 1.21 1.21 4.79-4.79 4.79 4.79 1.21-1.21-4.79-4.79 4.79-4.79"
                  ></path>
                </svg>
              </div>
            </li>
          </ul>
        </div>

        <div class="major-menu--wrapper">
          <ul class="major-menu--type-wrapper">
            <li class="major-menu--type-item major-menu--type-item---active">
              <p class="major-menu--type-item-name major-menu--type-item---active">Developer portal</p>
            </li>
          </ul>
          <ul class="major-menu--additional-wrapper">
            <li class="major-menu--additional-item">
              <a
                class="major-menu--additional-item-link"
                href="https://urbo.lt/en/private/faq/daily-banking/e-banking"
                target="_self"
              >
                <div class="major-menu--additional-item-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    class
                  >
                    <path
                      transform="translate(-1035 -11)"
                      d="M1043.99 11a9 9 0 1 1 .01 18 9 9 0 0 1-.01-18zm.01 16.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4zm-.86-3.02c0-.45.39-.82.86-.82s.86.37.86.82c0 .45-.39.82-.86.82a.85.85 0 0 1-.86-.82zM1044 15h.01a2.93 2.93 0 0 1 2.99 2.85c0 1.29-.89 2.38-2.14 2.74v.14c0 .45-.39.82-.86.82a.85.85 0 0 1-.86-.82v-.82c0-.45.39-.82.86-.82.71 0 1.29-.55 1.29-1.23 0-.67-.58-1.22-1.29-1.22-.71 0-1.29.55-1.29 1.22 0 .46-.38.82-.85.82a.83.83 0 0 1-.86-.82 2.93 2.93 0 0 1 3-2.86z"
                    ></path>
                  </svg>
                </div>
              </a>
            </li>
            <li class="major-menu--additional-item">
              <div
                class="major-menu--additional-item-contacts-open"
                id="contacts-open"
                contacts-trigger="contacts-menu"
              ></div>
              <div class="major-menu--additional-item-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  class
                >
                  <path
                    transform="translate(-730 -1535)"
                    d="M739 1535a9 9 0 1 1 0 18.01 9 9 0 0 1 0-18.01zm0 16.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4zm3.73-5.32a.38.38 0 0 1 .26.34 1.6 1.6 0 0 1-.6 1.34l-.1.08-.05.04a.83.83 0 0 1-.07.06l-.07.04c-1.04.6-3-.1-4.72-1.7a7.92 7.92 0 0 1-.2-.2l-.04-.03-.04-.03-.2-.2c-1.59-1.72-2.28-3.69-1.69-4.72l.05-.08a.83.83 0 0 1 .05-.07l.04-.06.08-.1c.33-.4.83-.62 1.35-.58.09 0 .18.04.24.1l.09.15.13.38.5 1.47c.04.13.01.27-.08.37l-.43.5c-.1.1-.11.26-.05.38a4.99 4.99 0 0 0 2.45 2.47c.13.06.28.03.39-.06l.5-.44c.1-.09.24-.12.37-.07l1.47.5.37.13z"
                  ></path>
                </svg>
              </div>
            </li>
            <li
              v-if="!name"
              class="major-menu--additional-item major-menu--additional-item---special"
            >
              <a
                class="major-menu--additional-item-link"
                href="javascript:void(0)"
                v-on:click="loginWindow"
              >
                <div class="major-menu--additional-item-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    class
                  >
                    <path
                      d="M0 9a9 9 0 1 0 17.98.02A9 9 0 0 0 0 9zm1.8 0a7.2 7.2 0 1 1 14.4 0A7.2 7.2 0 0 1 1.8 9zM11 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm-2 3c1.33 0 4 .67 4 2v1H5v-1c0-1.33 2.67-2 4-2z"
                    ></path>
                  </svg>
                </div>
                <div class="major-menu--additional-item-name">Login</div>
              </a>
            </li>
            <li
              v-if="name"
              class="major-menu--additional-item major-menu--additional-item---special"
            >
              <a v-on:click="logout" class="major-menu--additional-item-link" href="#">
                <div class="major-menu--additional-item-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    class
                  >
                    <path
                      d="M0 9a9 9 0 1 0 17.98.02A9 9 0 0 0 0 9zm1.8 0a7.2 7.2 0 1 1 14.4 0A7.2 7.2 0 0 1 1.8 9zM11 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm-2 3c1.33 0 4 .67 4 2v1H5v-1c0-1.33 2.67-2 4-2z"
                    ></path>
                  </svg>
                </div>
                <div class="major-menu--additional-item-name">Logout</div>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <header class="header">
        <div class="header--wrapper">
          <div class="header--logo">
            <router-link :to="{ name: 'getting-started'}">
              <img src="/images/mb-logo.svg" />
              <!--<svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="236"
                height="16"
                viewBox="0 0 236 16"
                class
              >
                <path
                  transform="translate(-130 -72)"
                  d="M147.86 87.5v-.56c.46 0 .78-.18.96-.53.18-.35.28-.94.28-1.75v-9.28c0-.81-.1-1.4-.28-1.75-.18-.34-.5-.52-.96-.52v-.57h10.74c.66 0 1.1-.12 1.32-.37l1.15 5.24-.5.16a4.74 4.74 0 0 0-1.78-2.58 5.06 5.06 0 0 0-3.04-.95c-.62 0-1.08.07-1.38.21a1 1 0 0 0-.56.64c-.08.28-.12.7-.12 1.25v1.3h1.33a3.6 3.6 0 0 0 1.74-.34c.39-.23.59-.73.59-1.5l.44-.08.99 5.78-.45.04a4.47 4.47 0 0 0-1.1-1.68 2.4 2.4 0 0 0-1.02-.59c-.36-.1-.8-.14-1.3-.14h-1.22v4.39l-.02.55c0 .81.18 1.38.55 1.68.36.3.9.45 1.64.45 2.58 0 4.55-1.4 5.9-4.23l.47.19-1.9 5.9c-.24-.24-.7-.36-1.35-.36zm22.05-13.46c-.56 0-.92.18-1.06.53-.14.35-.21.86-.21 1.52v7.4c0 .6.03 1.08.09 1.41.05.34.2.6.43.8.23.2.59.3 1.07.3.46 0 .87-.07 1.26-.2a3.2 3.2 0 0 0 1.02-.6 4.84 4.84 0 0 0 1.38-2.07c.3-.83.44-1.7.44-2.59a9.33 9.33 0 0 0-1.08-4.3 4.72 4.72 0 0 0-1.76-1.82c-.48-.26-1-.38-1.58-.38zm1.2 13.46h-8.3v-.56c.46 0 .78-.18.96-.53.18-.35.27-.94.27-1.75v-9.28c0-.81-.09-1.4-.27-1.75-.18-.34-.5-.52-.96-.52v-.57h7.13c.56 0 1.08.03 1.55.06l.23.02c.52.04 1.04.13 1.56.25a7.06 7.06 0 0 1 2.91 1.42 7.38 7.38 0 0 1 2.13 2.74 8.18 8.18 0 0 1 .22 6.38c-.37.93-.9 1.72-1.62 2.36-1.21 1.1-3.02 1.67-5.43 1.73h-.39zM133.1 75.56v8.99c0 .84.1 1.44.3 1.81.19.37.54.56 1.04.58v.56H130v-.56c.45 0 .76-.18.93-.53.18-.35.26-.93.26-1.75v-9.28c0-.82-.08-1.4-.26-1.75-.17-.35-.48-.52-.93-.52v-.57h7.56v.57c-.35.1-.52.28-.52.55 0 .11.05.33.15.65l.23.57 1.32 3.05 1.62-3.23c.23-.53.35-.88.35-1.04a.54.54 0 0 0-.37-.55v-.57h7.1v.57c-.45 0-.77.18-.95.53-.2.35-.28.93-.28 1.74v9.28c0 .8.09 1.4.28 1.74.18.36.5.54.95.54v.56h-7.1v-.56c.45 0 .78-.18.98-.54.2-.35.3-.93.3-1.74v-9.1l-4.31 8.96zm89.75-.18c0-1.52-.46-2.27-1.37-2.27v-.57h4.5v.57c-.45 0-.76.18-.95.53-.19.35-.28.93-.28 1.74v9.25c0 .82.1 1.4.28 1.75.19.35.5.53.95.53v.57h-4.5v-.54c.76-.13 1.14-.56 1.14-1.3 0-.48-.11-.92-.34-1.3-.22-.4-.55-.83-.98-1.32l-6.66-7.78v9.42c0 .8.09 1.39.27 1.74.18.36.5.54.94.54v.56h-4.35v-.56c.46 0 .77-.18.96-.53.18-.35.27-.94.27-1.75v-9.28c0-.81-.09-1.4-.27-1.75-.19-.35-.5-.52-.96-.52v-.57h8.57v.57c-.4.11-.6.31-.6.61 0 .27.3.76.9 1.46l2.48 3.07zm-11.8 12.12H204v-.56c.46 0 .78-.18.96-.53.18-.35.27-.94.27-1.75v-9.28c0-.81-.09-1.4-.27-1.75-.18-.35-.5-.52-.96-.52v-.57h7.07v.57c-.45 0-.77.18-.96.53-.19.36-.28.94-.28 1.74v9.28c0 .8.1 1.38.28 1.74.19.36.5.54.96.54zm-9.21.5a.73.73 0 0 0-.41-.3 2.94 2.94 0 0 0-.67-.06l-3.2.23c-1.26 0-2.45-.17-3.6-.52a9.34 9.34 0 0 1-3.03-1.55c-.9-.7-1.6-1.55-2.1-2.59a7.93 7.93 0 0 1-.76-3.53c0-1.18.22-2.25.64-3.19a6.55 6.55 0 0 1 1.78-2.37 7.92 7.92 0 0 1 2.64-1.45c1-.33 2.07-.5 3.2-.5.95 0 2.02.12 3.23.35.35.06.63.1.82.1.52 0 .9-.21 1.12-.62l1.28 6.46-.47.13a8.63 8.63 0 0 0-1.13-2.21 5.94 5.94 0 0 0-1.73-1.65 4.17 4.17 0 0 0-4.52.1 4.41 4.41 0 0 0-1.44 1.9 6.53 6.53 0 0 0-.49 2.5c0 .8.12 1.59.34 2.37.23.79.55 1.49.98 2.09a5.47 5.47 0 0 0 4.31 2.25 4.64 4.64 0 0 0 4.46-3.1l.52.19zm-14.55-.5h-7.06v-.56c.45 0 .77-.18.95-.53.19-.35.28-.94.28-1.75v-9.28c0-.81-.1-1.4-.28-1.75-.18-.35-.5-.52-.95-.52v-.57h7.06v.57c-.45 0-.76.18-.95.53-.2.36-.29.94-.29 1.74v9.28a4 4 0 0 0 .29 1.74c.19.36.5.54.95.54zm47.16-13.4c-.54 0-1.01.19-1.42.55-.42.36-.74.83-1 1.4a7.8 7.8 0 0 0-.52 3.09c0 1.66.24 3.08.7 4.25.3.72.69 1.32 1.2 1.81a2.45 2.45 0 0 0 1.74.74c.57 0 1.08-.19 1.52-.55.43-.37.75-.85.97-1.43.3-.76.45-1.77.45-3 0-1.72-.21-3.13-.63-4.26-.17-.45-.41-.87-.7-1.26a3.8 3.8 0 0 0-1.03-.96 2.47 2.47 0 0 0-1.28-.37zm-2.83 13.28a6.64 6.64 0 0 1-4-3.19 7.99 7.99 0 0 1-.78-2.03 9.35 9.35 0 0 1-.26-2.18c0-1.2.21-2.28.63-3.25a7.07 7.07 0 0 1 1.77-2.47 7.8 7.8 0 0 1 2.64-1.55 9.76 9.76 0 0 1 3.18-.53h.08c.72 0 1.42.07 2.11.2.7.13 1.36.35 2 .64a6.78 6.78 0 0 1 3.44 3.8 9.49 9.49 0 0 1 .34 5.4 7.86 7.86 0 0 1-.75 1.94c-.33.6-.74 1.14-1.22 1.6a7.23 7.23 0 0 1-2.7 1.56 9.97 9.97 0 0 1-3.22.55h-.08c-1.08-.01-2.14-.17-3.18-.5zm24.82-10.34l-.47.07a4.5 4.5 0 0 0-.67-1.19c-.3-.38-.62-.71-1-1a4.68 4.68 0 0 0-1.23-.68 3.75 3.75 0 0 0-1.32-.24c-.55 0-1.08.16-1.56.48-.48.33-.72.76-.72 1.32 0 .48.18.83.53 1.04.36.21.9.44 1.62.68l2.63.8c.74.23 1.39.5 1.94.83.54.32.98.74 1.3 1.27.32.52.48 1.17.48 1.94 0 1.73-.8 3.12-2.38 4.16a8.8 8.8 0 0 1-5.04 1.35c-.85 0-1.9-.12-3.14-.35a8.9 8.9 0 0 0-1.48-.22c-.44 0-.84.18-1.21.54l-.5-6.34.5-.07c.14.87.46 1.66.95 2.36a5.09 5.09 0 0 0 5.75 2.03c.46-.15.84-.39 1.15-.73.31-.33.47-.77.47-1.3 0-.54-.19-.94-.56-1.19-.37-.24-.89-.47-1.57-.7l-2.27-.74a8.14 8.14 0 0 1-2.6-1.23 3.67 3.67 0 0 1-1.32-2.75 4.86 4.86 0 0 1 2.06-3.77 7.19 7.19 0 0 1 4.22-1.23c.5 0 1.27.1 2.3.3.64.12 1.02.17 1.17.17.63 0 1.1-.18 1.39-.54zm20.89-3c-.71 0-1.2.11-1.44.34-.15.16-.22.5-.22 1.05v2.93a8.9 8.9 0 0 0 1.85-.67c.48-.23.9-.53 1.25-.89.4-.4.6-.87.6-1.4 0-.48-.2-.83-.62-1.04-.37-.19-.78-.3-1.23-.32h-.2zm-1.66 5.95v4.5c0 .45.02.77.07.96.05.2.17.34.35.42.19.1.5.13.93.13a4.49 4.49 0 0 0 1.71-.35c.5-.23.9-.58 1.18-1.05.28-.46.42-1.02.42-1.69 0-.8-.21-1.52-.65-2.14a5.07 5.07 0 0 0-1.77-1.54l-.39.13zm-5.83 7.51v-.56c.45 0 .77-.18.96-.53.18-.35.28-.94.28-1.75v-9.28c0-.81-.1-1.4-.28-1.75-.19-.34-.5-.52-.96-.52v-.57h9.93c.78 0 1.44.05 1.99.12.54.08 1.02.28 1.43.6.41.34.62.84.62 1.53 0 .84-.37 1.54-1.1 2.1-.74.57-1.63 1.05-2.67 1.47.9.15 1.73.43 2.5.82.75.4 1.37.93 1.84 1.59.47.67.7 1.45.7 2.36 0 .77-.2 1.46-.58 2.07a5.11 5.11 0 0 1-3.54 2.15c-.72.1-1.54.15-2.45.15zm22.91-11.93l-1.41 4.27c.52 0 1.04.1 1.56.28.51.19 1.04.47 1.56.83l-1.56-4.91zm-2.1 6.2l-.81 2.32a6.85 6.85 0 0 0-.43 1.84c0 .59.34.92 1.03 1v.57h-4.93v-.56c.38-.1.7-.27.95-.53.26-.26.46-.54.6-.83.15-.3.34-.7.56-1.24l3.52-9.43c.25-.6.38-1.02.38-1.23 0-.33-.17-.52-.5-.57v-.57h6.55v.57c-.34.04-.51.23-.51.57 0 .07.11.48.35 1.2l.88 2.72 1.33 3.98.93 2.78.3.88c.1.26.21.53.34.77.14.25.31.45.5.62.2.17.45.27.72.3v.57h-7.73v-.56c.37-.03.67-.17.9-.4.22-.24.33-.55.33-.93 0-.52-.19-1.03-.57-1.56a5.17 5.17 0 0 0-1.31-1.28 5.25 5.25 0 0 0-1.13-.6 6.15 6.15 0 0 0-2.26-.4zm23.64-6.39c0-1.52-.45-2.27-1.36-2.27v-.57h4.5v.57c-.45 0-.77.18-.95.53a4 4 0 0 0-.28 1.74v9.25a4 4 0 0 0 .28 1.75c.18.35.5.53.95.53v.57h-4.5v-.54c.76-.13 1.14-.56 1.14-1.3 0-.48-.11-.92-.34-1.3-.23-.4-.56-.83-.98-1.32l-6.67-7.78v9.42c0 .8.1 1.39.28 1.74.18.36.49.54.94.54v.56h-4.35v-.56c.45 0 .77-.18.95-.53.19-.35.28-.94.28-1.75v-9.28c0-.81-.1-1.4-.28-1.75-.18-.35-.5-.52-.95-.52v-.57h8.56v.57c-.39.11-.59.31-.59.61 0 .27.3.76.9 1.46l2.47 3.07zm20.09 11.55h.04c.36-.1.65-.27.9-.52.26-.26.46-.54.61-.83.15-.3.33-.7.55-1.24l3.52-9.43c.25-.6.38-1.02.38-1.23 0-.33-.17-.52-.5-.57v-.57h1.88v3.5l-.15-.47-1.41 4.27c.52 0 1.04.1 1.56.28v2.05a6.18 6.18 0 0 0-2.26-.4l-.8 2.32a6.85 6.85 0 0 0-.43 1.84c0 .59.34.92 1.03 1v.57h-4.93v-.02h.1v-.54h-.09zm0 0v.55h-7.56v-.54c.68-.03 1.03-.3 1.03-.78 0-.4-.14-.98-.41-1.76a16.1 16.1 0 0 0-.78-1.92c-.48-.99-1.19-2.06-2.15-3.21l-.79.72v4.67c0 .78.12 1.36.34 1.73.23.36.57.55 1.03.55v.56h-7.2v-.56c.46 0 .78-.18.96-.53.19-.35.28-.94.28-1.75v-9.28c0-.81-.1-1.4-.28-1.75-.18-.35-.5-.52-.95-.52v-.57h7.03l.03.57c-.46 0-.77.2-.96.57-.18.37-.28.98-.28 1.81v2.62l2.4-2.18c.2-.18.4-.4.63-.63.23-.24.43-.48.6-.72.19-.25.27-.45.27-.63a.7.7 0 0 0-.32-.6 1.4 1.4 0 0 0-.73-.24v-.57h6.5v.57c-1.3.2-2.7.94-4.2 2.23l-1.16 1c.8.82 1.5 1.69 2.1 2.6a21.7 21.7 0 0 1 1.55 2.9c.45 1 .88 2.11 1.29 3.32.21.6.44 1.04.7 1.34.22.27.57.42 1.03.43zm30.1-9.89l-.48.07a4.56 4.56 0 0 0-.66-1.19c-.3-.38-.63-.71-1.01-1a4.63 4.63 0 0 0-1.23-.68 3.75 3.75 0 0 0-1.31-.24c-.56 0-1.08.16-1.56.48-.49.33-.73.76-.73 1.32 0 .48.18.83.53 1.04.36.21.9.44 1.63.68l2.62.8c.74.23 1.4.5 1.94.83.55.32.98.74 1.3 1.27.32.52.48 1.17.48 1.94 0 1.73-.8 3.12-2.38 4.16a8.8 8.8 0 0 1-5.04 1.35c-.84 0-1.9-.12-3.14-.35a8.93 8.93 0 0 0-1.48-.22c-.44 0-.84.18-1.2.54l-.5-6.34.5-.07c.13.87.45 1.66.94 2.36a5.1 5.1 0 0 0 5.75 2.03c.46-.15.85-.39 1.15-.73.31-.33.47-.77.47-1.3 0-.54-.18-.94-.56-1.19-.37-.24-.89-.47-1.57-.7l-2.27-.74a8.12 8.12 0 0 1-2.6-1.23 3.65 3.65 0 0 1-1.05-4.18 4.9 4.9 0 0 1 1.8-2.34 7.17 7.17 0 0 1 4.2-1.23c.52 0 1.28.1 2.32.3.63.12 1.02.17 1.16.17.63 0 1.1-.18 1.4-.54zm-21.6 5.73c.5.33.94.76 1.32 1.28.38.53.57 1.04.57 1.56 0 .38-.1.7-.34.93-.22.23-.52.37-.89.4v.56h7.73v-.56a1.36 1.36 0 0 1-.71-.31c-.2-.17-.37-.37-.5-.62-.14-.24-.25-.5-.35-.77l-.3-.88-.93-2.78-1.33-3.98-.88-2.71c-.24-.73-.35-1.14-.35-1.21 0-.34.17-.53.51-.57v-.57h-4.67v3.5l1.56 4.91a6.54 6.54 0 0 0-1.56-.83v2.05c.4.15.78.36 1.13.6z"
                ></path>
              </svg>-->
            </router-link>
          </div>
          <ul class="header--list">
            <li class="header--item">
              <router-link :to="{ name: 'getting-started'}">
                <div class="header--item-clickable-area"></div>
                <div class="header--item-name">Home</div>
              </router-link>
            </li>
            <li class="header--item">
              <router-link active-class="active" :to="{ name: 'news'}">
                <div class="header--item-clickable-area"></div>
                <div class="header--item-name">News</div>
              </router-link>
            </li>
            <li class="header--item">
              <div class="header--item-clickable-area"></div>
              <div class="header--item-name">APIs</div>
              <div class="header--item-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                  <path d="M14 0v14H0z"></path>
                </svg>
              </div>
              <ul class="header--sub-menu-content" sub-menu-target="header--sub-menu-content-box">
                <li class="header--sub-menu-content-item accountListClick">
                  <router-link
                    :to="{ name: 'api-explorer-account-list' }"
                    class="header--sub-menu-content-item-link"
                  >
                    <div class="header--sub-menu-content-item-name">
                      <img src="/images/icon-account-list.svg" width="40" height="40" alt>
                      <p>Account list</p>
                    </div>
                    <div class="header--sub-menu-content-item-description">
                      <p>Account list via SCA Redirect approach</p>
                    </div>
                  </router-link>
                </li>
                <li class="header--sub-menu-content-item accountsClick">
                  <router-link
                    :to="{ name: 'api-explorer-accounts' }"
                    class="header--sub-menu-content-item-link"
                  >
                    <div class="header--sub-menu-content-item-name">
                      <img src="/images/icon-accounts.svg" width="40" height="40" alt>
                      <p>Accounts</p>
                    </div>
                    <div class="header--sub-menu-content-item-description">
                      <p>Statements and account balance information</p>
                    </div>
                  </router-link>
                </li>
                <li class="header--sub-menu-content-item paymentsClick">
                  <router-link
                    :to="{ name: 'api-explorer-payments' }"
                    class="header--sub-menu-content-item-link"
                  >
                    <div class="header--sub-menu-content-item-name">
                      <img src="/images/icon-payments.svg" width="40" height="40" alt>
                      <p>Payments</p>
                    </div>
                    <div class="header--sub-menu-content-item-description">
                      <p>Initiate and confirm payments via API</p>
                    </div>
                  </router-link>
                </li>
              </ul>
              <!-- Settings -->
            </li>
            <li v-bind:style=" !name ? 'display: none;' : '' " class="header--item">
              <div class="header--item-clickable-area"></div>
              <div class="header--item-name">Settings</div>
              <div class="header--item-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                  <path d="M14 0v14H0z"></path>
                </svg>
              </div>
              <ul class="header--sub-menu-content" sub-menu-target="header--sub-menu-content-box">
                <li class="header--sub-menu-content-item tppClick">
                  <router-link
                    :to="{ name: 'tpp-certificate' }"
                    class="header--sub-menu-content-item-link"
                  >
                    <div class="header--sub-menu-content-item-name">
                      <img src="/images/icon-certificate.svg" width="40" height="40" alt>
                      <p>Tpp certificate</p>
                    </div>
                    <div class="header--sub-menu-content-item-description">
                      <p>Tpp certificate is needed to perform API calls outside of the portal</p>
                    </div>
                  </router-link>
                </li>
                <!-- QSEAL sertificate -->
                <li class="header--sub-menu-content-item qsealClick">
                  <router-link
                    :to="{ name: 'qseal-certificate' }"
                    class="header--sub-menu-content-item-link"
                  >
                    <div class="header--sub-menu-content-item-name">
                      <img src="/images/icon-certificate-qseal.svg" width="40" height="40" alt>
                      <p>QSEAL certificate</p>
                    </div>
                    <div class="header--sub-menu-content-item-description">
                      <p>QSEAL certificate is needed to perform API calls outside of the portal</p>
                    </div>
                  </router-link>
                </li>
                <!--/. QSEAL sertificate -->
              </ul>
            </li>
            <!--/. Settings -->
          </ul>
        </div>
        <div class="header--sub-menu">
          <div class="header--sub-menu-wrapper">
            <div class="header--sub-menu-content-box"></div>
            <button class="header--sub-menu-close-button">Close</button>
          </div>
          <div class="header--sub-menu-shade"></div>
        </div>
      </header>
      <header class="header-mobile">
        <div class="header-mobile--contacts">
          <ul class="header-mobile--contacts-wrapper">
            <li class="header-mobile--contacts-item">
              <a class="header-mobile--contacts-link" href="tel:+370 5 264 4800" target="_self">
                <div class="header-mobile--contacts-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    class
                  >
                    <path
                      transform="translate(-730 -1535)"
                      d="M739 1535a9 9 0 1 1 0 18.01 9 9 0 0 1 0-18.01zm0 16.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4zm3.73-5.32a.38.38 0 0 1 .26.34 1.6 1.6 0 0 1-.6 1.34l-.1.08-.05.04a.83.83 0 0 1-.07.06l-.07.04c-1.04.6-3-.1-4.72-1.7a7.92 7.92 0 0 1-.2-.2l-.04-.03-.04-.03-.2-.2c-1.59-1.72-2.28-3.69-1.69-4.72l.05-.08a.83.83 0 0 1 .05-.07l.04-.06.08-.1c.33-.4.83-.62 1.35-.58.09 0 .18.04.24.1l.09.15.13.38.5 1.47c.04.13.01.27-.08.37l-.43.5c-.1.1-.11.26-.05.38a4.99 4.99 0 0 0 2.45 2.47c.13.06.28.03.39-.06l.5-.44c.1-.09.24-.12.37-.07l1.47.5.37.13z"
                    ></path>
                  </svg>
                </div>
                <div class="header-mobile--contacts-name">+370 5 264 4800</div>
              </a>
            </li>
            <li class="header-mobile--contacts-item">
              <a
                class="header-mobile--contacts-link"
                href="https://urbo.lt/en/contact-us"
                target="_blank"
              >
                <div class="header-mobile--contacts-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                  >
                    <path
                      transform="translate(-731 -21)"
                      d="M739.99 21a9 9 0 1 1 .01 18 9 9 0 0 1-.01-18zm.01 16.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4zm3.2-10.2c.44 0 .8.34.8.75v4.5c0 .41-.36.75-.8.75h-6.4c-.44 0-.8-.34-.8-.75v-4.5c0-.41.36-.75.8-.75zm0 1.5v-.75l-3.2 1.88-3.2-1.88v.75l3.2 1.88z"
                    ></path>
                  </svg>
                </div>
                <div class="header-mobile--contacts-name">Contact us</div>
              </a>
            </li>
          </ul>
        </div>
        <div class="header-mobile--main">
          <div class="header-mobile--main-wrapper">
            <div class="header-mobile--main-wrapper-container">
              <router-link :to="{ name: 'getting-started'}">
                <img src="/images/mb-logo.svg" />
                <!--<svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="161"
                  height="11"
                  viewBox="0 0 161 11"
                  class="header-mobile--main-logo"
                >
                  <defs>
                    <path
                      id="logo-mobile"
                      d="M27.19 73.66v-.39c.31 0 .52-.12.65-.36.12-.25.19-.65.19-1.21v-6.37c0-.56-.07-.96-.19-1.21-.13-.24-.34-.36-.65-.36v-.39h7.32c.45 0 .75-.08.9-.25l.78 3.6-.33.11a3.26 3.26 0 0 0-1.22-1.77 3.4 3.4 0 0 0-3.01-.51.7.7 0 0 0-.39.44c-.05.19-.08.47-.08.85v.9h.91c.52 0 .92-.08 1.18-.24.27-.15.41-.5.41-1.03l.3-.05.67 3.97-.3.03a3.19 3.19 0 0 0-.75-1.16c-.22-.2-.45-.33-.7-.4-.25-.06-.54-.1-.89-.1h-.83v3.02l-.01.38c0 .56.12.95.37 1.15.25.21.62.32 1.12.32 1.76 0 3.11-.97 4.03-2.91l.32.12-1.3 4.07c-.16-.17-.47-.25-.92-.25zm15.04-9.26c-.39 0-.63.12-.72.37-.1.24-.15.59-.15 1.04v5.1c0 .41.02.73.06.96.04.23.14.41.29.55.16.14.41.21.74.21.31 0 .59-.05.85-.14.26-.09.49-.23.7-.42.42-.36.74-.84.94-1.42.2-.57.3-1.16.3-1.78a6.65 6.65 0 0 0-.73-2.95 3.14 3.14 0 0 0-.95-1.09c-.08-.07-.17-.12-.26-.17a2.26 2.26 0 0 0-1.07-.26zm.81 9.26h-5.66v-.39c.31 0 .53-.12.66-.36.12-.25.19-.65.19-1.21v-6.37c0-.56-.07-.96-.19-1.21-.13-.24-.35-.36-.66-.36v-.39h4.86l1.06.04.16.02a6.33 6.33 0 0 1 2.09.53 5.04 5.04 0 0 1 2.41 2.5 5.61 5.61 0 0 1 .15 4.39 4.17 4.17 0 0 1-1.1 1.62c-.83.75-2.06 1.15-3.71 1.18l-.26.01zm-25.93-8.21v6.18c0 .58.07.99.2 1.24.14.26.37.39.72.4v.39H15v-.39c.31 0 .52-.12.63-.36.12-.24.18-.64.18-1.21v-6.37c0-.57-.06-.97-.17-1.21-.12-.24-.33-.36-.64-.36v-.39h5.16v.39c-.24.07-.36.2-.36.38 0 .08.04.23.11.45l.15.39.91 2.1 1.1-2.22c.16-.37.24-.61.24-.72 0-.19-.09-.31-.26-.38v-.39h4.85v.39c-.31 0-.53.12-.65.37a2.7 2.7 0 0 0-.19 1.2v6.37c0 .56.06.96.19 1.2.12.25.34.37.65.37v.39h-4.85v-.39c.31 0 .53-.12.67-.37.13-.24.2-.64.2-1.2v-6.25l-2.93 6.16zm61.23-.12c0-1.05-.31-1.57-.93-1.57v-.39h3.07v.39c-.31 0-.52.12-.65.37a2.7 2.7 0 0 0-.19 1.2v6.36c0 .56.06.96.19 1.2s.34.36.65.36v.39h-3.07v-.37c.52-.09.78-.39.78-.9 0-.33-.08-.63-.24-.89a4.94 4.94 0 0 0-.67-.9l-4.54-5.35v6.47c0 .56.06.96.19 1.2.12.25.33.37.64.37v.39H70.6v-.39c.31 0 .53-.12.65-.36.13-.25.19-.65.19-1.21v-6.37c0-.56-.06-.96-.19-1.21-.12-.24-.34-.36-.65-.36v-.39h5.84v.39c-.26.08-.4.22-.4.43 0 .18.21.51.61 1l1.69 2.11zm-8.04 8.33h-4.82v-.39c.31 0 .52-.12.65-.36.12-.25.19-.65.19-1.21v-6.37c0-.56-.07-.96-.19-1.21-.13-.24-.34-.36-.65-.36v-.39h4.82v.39c-.31 0-.53.12-.66.37-.12.25-.19.64-.19 1.2v6.37c0 .55.07.95.19 1.2.13.25.35.37.66.37zm-6.29.34a.51.51 0 0 0-.28-.21 2.48 2.48 0 0 0-.45-.04l-2.19.16c-.86 0-1.67-.12-2.45-.36a6.3 6.3 0 0 1-2.08-1.06 5.19 5.19 0 0 1-1.94-4.21c0-.81.14-1.54.43-2.19.29-.65.7-1.19 1.22-1.63a5.28 5.28 0 0 1 1.8-1 6.77 6.77 0 0 1 2.18-.34c.65 0 1.38.08 2.2.24.24.04.43.06.57.06.35 0 .6-.14.76-.42l.87 4.44-.32.09a6.21 6.21 0 0 0-.77-1.52 3.96 3.96 0 0 0-1.18-1.13 2.82 2.82 0 0 0-1.52-.43c-.61 0-1.13.16-1.57.49-.43.33-.76.77-.98 1.31a4.47 4.47 0 0 0-.33 1.72c0 .55.08 1.09.23 1.63.15.54.38 1.02.67 1.44.34.47.78.85 1.3 1.13.53.27 1.07.41 1.64.41a3.26 3.26 0 0 0 3.05-2.12l.35.12zm-9.92-.34h-4.82v-.39c.31 0 .52-.12.65-.36.12-.25.19-.65.19-1.21v-6.37c0-.56-.07-.96-.19-1.21-.13-.24-.34-.36-.65-.36v-.39h4.82v.39c-.31 0-.53.12-.66.37s-.19.64-.19 1.2v6.37c0 .55.06.95.19 1.2s.35.37.66.37zm32.17-9.21c-.37 0-.7.12-.98.37s-.5.57-.67.96a5.37 5.37 0 0 0-.36 2.13c0 1.14.16 2.12.48 2.92.2.5.47.91.81 1.25.28.27.6.44.96.49l.23.01c.39 0 .74-.12 1.04-.38.29-.25.51-.58.66-.98.21-.52.31-1.21.31-2.06 0-1.18-.14-2.15-.43-2.93a3.45 3.45 0 0 0-1.18-1.53c-.2-.12-.41-.2-.63-.23-.08-.02-.16-.02-.24-.02zm-1.93 9.12a4.68 4.68 0 0 1-3.27-3.58c-.11-.49-.17-1-.17-1.51a5.04 5.04 0 0 1 3.44-4.99 6.63 6.63 0 0 1 2.17-.37h.05c.49 0 .97.05 1.44.14a6 6 0 0 1 1.36.44 4.45 4.45 0 0 1 2.35 2.61 6.52 6.52 0 0 1 .23 3.72 5.23 5.23 0 0 1-1.34 2.43c-.5.47-1.11.83-1.85 1.07-.73.25-1.46.38-2.19.38h-.05a7.62 7.62 0 0 1-2.17-.34zm16.93-7.1l-.32.04a3.3 3.3 0 0 0-.46-.81 3.47 3.47 0 0 0-1.52-1.16 2.6 2.6 0 0 0-.9-.17c-.38 0-.74.11-1.06.34-.33.22-.5.52-.5.9 0 .33.12.57.37.72.24.14.61.3 1.1.47l1.79.54c.51.16.95.35 1.33.57.37.23.66.52.88.88.22.36.33.8.33 1.33a3.3 3.3 0 0 1-1.62 2.86c-.9.62-2.05.93-3.44.93-.58 0-1.29-.08-2.14-.24-.5-.1-.84-.15-1.01-.15-.31 0-.58.12-.83.37l-.34-4.36.34-.05c.1.6.32 1.15.65 1.63s.75.86 1.26 1.14a3.48 3.48 0 0 0 2.66.25c.32-.1.58-.27.79-.5.21-.23.32-.53.32-.89 0-.38-.13-.65-.38-.82a4.28 4.28 0 0 0-1.08-.48l-1.54-.51a5.78 5.78 0 0 1-1.78-.85 2.66 2.66 0 0 1-.66-.85 2.4 2.4 0 0 1-.24-1.04c0-.32.06-.65.18-.98a3.38 3.38 0 0 1 1.23-1.61c.8-.57 1.76-.85 2.87-.85.35 0 .88.07 1.58.21.43.08.69.12.79.12.43 0 .75-.13.95-.37zm14.25-2.07c-.49 0-.81.08-.98.24-.1.1-.15.34-.15.72v2.01a5.89 5.89 0 0 0 1.26-.46c.33-.16.61-.36.85-.61.27-.28.41-.6.41-.96a.76.76 0 0 0-.42-.72c-.25-.13-.53-.2-.84-.21l-.13-.01zm-1.13 4.1v3.09c0 .31.01.52.05.66.03.13.11.23.23.29.13.06.34.09.64.09l.34-.02c.3-.03.57-.11.82-.22.35-.17.62-.41.81-.72.19-.32.29-.71.29-1.17a2.5 2.5 0 0 0-.45-1.47c-.3-.43-.7-.78-1.2-1.06l-.27.09zm-3.98 5.16v-.39c.31 0 .53-.12.65-.36.13-.25.19-.65.19-1.21v-6.37c0-.56-.06-.96-.19-1.21-.12-.24-.34-.36-.65-.36v-.39h6.78c.53.01.98.04 1.35.09.37.05.69.19.97.41.29.23.43.58.43 1.05 0 .58-.25 1.06-.75 1.44-.5.39-1.11.73-1.82 1.01.61.11 1.18.3 1.7.57.52.27.94.63 1.26 1.09.32.46.48 1 .48 1.62 0 .53-.14 1.01-.4 1.42a3.46 3.46 0 0 1-2.41 1.48c-.5.07-1.05.11-1.68.11zm15.63-8.21l-.96 2.94a3.93 3.93 0 0 1 2.12.77l-1.06-3.39zm-1.44 4.27l-.55 1.59a4.86 4.86 0 0 0-.29 1.27c0 .4.23.63.7.69v.39h-3.36v-.39c.26-.06.47-.18.65-.36.17-.18.31-.37.41-.58.1-.2.23-.48.38-.85l2.4-6.48c.17-.42.26-.7.26-.85 0-.23-.11-.36-.34-.39v-.39h4.47v.39c-.24.03-.35.16-.35.39 0 .06.07.33.23.84l.61 1.86.91 2.74.63 1.91.2.6c.07.18.15.36.24.53.09.17.21.31.34.43.14.11.3.18.49.21v.39h-5.27v-.39a.85.85 0 0 0 .6-.28.85.85 0 0 0 .23-.63c0-.36-.12-.71-.38-1.07a3.84 3.84 0 0 0-3.21-1.57zm16.13-4.39c0-1.05-.31-1.57-.93-1.57v-.39h3.07v.39c-.3 0-.52.12-.65.37-.12.24-.19.64-.19 1.2v6.36c0 .56.07.96.19 1.2.13.24.35.36.65.36v.39h-3.07v-.37c.52-.09.78-.39.78-.9 0-.33-.08-.63-.23-.89a5.46 5.46 0 0 0-.67-.9l-4.55-5.35v6.47c0 .56.07.96.19 1.2.12.25.34.37.64.37v.39h-2.97v-.39c.32 0 .53-.12.66-.36.12-.25.18-.65.18-1.21v-6.37c0-.56-.06-.96-.18-1.21-.13-.24-.34-.36-.66-.36v-.39h5.85v.39c-.27.08-.4.22-.4.43 0 .18.2.51.61 1l1.68 2.11zm13.7 7.94l.04-.01c.24-.06.44-.18.61-.35.18-.18.31-.37.42-.58.1-.2.22-.48.37-.85l2.4-6.48c.17-.42.26-.7.26-.85 0-.23-.11-.36-.34-.39v-.39h1.28v2.4l-.1-.32-.96 2.94c.35 0 .71.07 1.06.2v1.4a4.18 4.18 0 0 0-1.54-.27l-.55 1.59a4.86 4.86 0 0 0-.29 1.27c0 .4.24.63.71.69v.39h-3.37v-.02h.07v-.37h-.06zm0 0v.37h-5.15v-.37c.47-.02.7-.2.7-.54 0-.26-.09-.67-.28-1.21a10.25 10.25 0 0 0-2-3.52l-.53.5v3.2c0 .54.08.94.23 1.19.15.25.39.38.7.38v.39h-4.91v-.39c.31 0 .53-.12.66-.36.12-.25.19-.65.19-1.21v-6.37c0-.56-.07-.96-.19-1.21-.13-.24-.35-.36-.66-.36v-.39h4.8l.02.39c-.31.01-.52.14-.65.4a2.9 2.9 0 0 0-.19 1.24v1.8l1.64-1.5.42-.43c.16-.16.3-.33.42-.5.12-.17.18-.31.18-.43a.5.5 0 0 0-.22-.42c-.16-.1-.32-.15-.5-.16v-.39h4.44v.39c-.89.14-1.85.65-2.88 1.53l-.78.69c.54.57 1.02 1.16 1.42 1.79.41.64.76 1.3 1.07 1.99.3.7.6 1.46.88 2.29a3 3 0 0 0 .47.92c.15.18.4.28.7.3zm20.54-6.8l-.32.04a3.3 3.3 0 0 0-.46-.81 3.47 3.47 0 0 0-1.52-1.16 2.6 2.6 0 0 0-.9-.17c-.38 0-.74.11-1.06.34-.33.22-.5.52-.5.9 0 .33.12.57.37.72.24.14.61.3 1.1.47l1.79.54c.51.16.95.35 1.33.57.37.23.66.52.88.88.22.36.33.8.33 1.33a3.3 3.3 0 0 1-1.62 2.86c-.9.62-2.05.93-3.44.93-.58 0-1.29-.08-2.14-.24-.5-.1-.84-.15-1.01-.15-.31 0-.58.12-.83.37l-.34-4.36.34-.05c.1.6.32 1.15.65 1.63s.75.86 1.26 1.14a3.48 3.48 0 0 0 2.66.25c.32-.1.58-.27.79-.5.21-.23.32-.53.32-.89 0-.38-.13-.65-.38-.82a4.28 4.28 0 0 0-1.08-.48l-1.54-.51a5.78 5.78 0 0 1-1.78-.85 2.66 2.66 0 0 1-.66-.85 2.4 2.4 0 0 1-.24-1.04c0-.32.06-.65.19-.98.12-.33.28-.64.5-.91.21-.28.45-.51.72-.7.8-.57 1.76-.85 2.87-.85a9 9 0 0 1 1.58.21c.43.08.7.12.79.12.43 0 .75-.13.95-.37zm-14.73 3.94c.34.22.64.52.9.88s.39.71.39 1.07c0 .26-.08.47-.23.63a.9.9 0 0 1-.61.28v.39h5.27v-.39a.96.96 0 0 1-.48-.21 1.65 1.65 0 0 1-.35-.43 5.05 5.05 0 0 1-.24-.53l-.2-.6-.63-1.91-.91-2.74-.6-1.86a7.02 7.02 0 0 1-.24-.84c0-.23.12-.36.35-.39v-.39h-3.19v2.4l1.07 3.39a3.98 3.98 0 0 0-1.07-.57v1.4c.28.11.53.25.77.42z"
                    ></path>
                  </defs>
                  <g transform="translate(-15 -63)">
                    <use xlink:href="#logo-mobile"></use>
                  </g>
                </svg>-->
              </router-link>
              <ul class="header-mobile--main-list">
                <li class="header-mobile--main-list-item">
                  <div class="header-mobile--main-toggle header-mobile--main-toggle---open">
                    <div class="header-mobile--main-toggle-click-area"></div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="19"
                      height="16"
                      viewBox="0 0 19 16"
                      class="header-mobile--sub-menu-main-open"
                    >
                      <path
                        transform="translate(-286 -60)"
                        d="M286 76h19v-2.56h-19zm0-6.72h19v-2.56h-19zm0-6.72h19V60h-19z"
                      ></path>
                    </svg>
                  </div>
                  <div class="header-mobile--main-toggle header-mobile--main-toggle---close">
                    <div class="header-mobile--main-toggle-click-area"></div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      class="header-mobile--sub-menu-main-close"
                    >
                      <path
                        transform="translate(-1298 -24)"
                        id="close"
                        d="M1310 25.21l-1.21-1.21-4.79 4.79-4.79-4.79-1.21 1.21 4.79 4.79-4.79 4.79 1.21 1.21 4.79-4.79 4.79 4.79 1.21-1.21-4.79-4.79 4.79-4.79"
                      ></path>
                    </svg>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="header-mobile--main-container">
            <div class="header-mobile--main-additional">
              <ul class="header-mobile--main-additional-wrapper">
                <li
                  class="header-mobile--main-additional-item header-mobile--main-additional-item---special-application"
                >
                  <div class="header-mobile--main-additional-item-name bg-none">Developer portal</div>
                </li>
                <li
                  v-if="!name"
                  class="header-mobile--main-additional-item header-mobile--main-additional-item---special-application"
                >
                  <a
                    class="header-mobile--main-additional-item-link"
                    href="javascript:void(0)"
                    v-on:click="loginWindow"
                  >
                    <div class="header-mobile--main-additional-item-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        class
                      >
                        <path
                          d="M0 9a9 9 0 1 0 17.98.02A9 9 0 0 0 0 9zm1.8 0a7.2 7.2 0 1 1 14.4 0A7.2 7.2 0 0 1 1.8 9zM11 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm-2 3c1.33 0 4 .67 4 2v1H5v-1c0-1.33 2.67-2 4-2z"
                        ></path>
                      </svg>
                    </div>
                    <div class="header-mobile--main-additional-item-name">Login</div>
                  </a>
                </li>
                <li
                  v-if="name"
                  class="header-mobile--main-additional-item header-mobile--main-additional-item---special-application"
                >
                  <a
                    v-on:click="logout"
                    class="header-mobile--main-additional-item-link"
                    href="javascript:void(0)"
                  >
                    <div class="header-mobile--main-additional-item-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        class
                      >
                        <path
                          d="M0 9a9 9 0 1 0 17.98.02A9 9 0 0 0 0 9zm1.8 0a7.2 7.2 0 1 1 14.4 0A7.2 7.2 0 0 1 1.8 9zM11 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm-2 3c1.33 0 4 .67 4 2v1H5v-1c0-1.33 2.67-2 4-2z"
                        ></path>
                      </svg>
                    </div>
                    <div class="header-mobile--main-additional-item-name">Logout</div>
                  </a>
                </li>
              </ul>
            </div>
            <div class="header-mobile--main-sub-menu">
                <ul class="header-mobile--main-sub-menu-list header-mobile--main-sub-menu-list---active">
                    <li class="header-mobile--main-sub-menu-item">
                        <router-link :to="{name:'getting-started'}">
                            <div class="header-mobile--main-sub-menu-item-clickable-area"></div>
                            <div class="header-mobile--main-sub-menu-item-wrapper">
                                <p class="header-mobile--main-sub-menu-item-name">Home</p>
                            </div>
                        </router-link>
                    </li>
                    <li class="header-mobile--main-sub-menu-item">
                        <router-link :to="{name:'news'}">
                            <div class="header-mobile--main-sub-menu-item-clickable-area"></div>
                            <div class="header-mobile--main-sub-menu-item-wrapper">
                                <p class="header-mobile--main-sub-menu-item-name">News</p>
                            </div>
                        </router-link>
                    </li>
                    <li class="header-mobile--main-sub-menu-item">
                        <div class="header-mobile--main-sub-menu-item-clickable-area"></div>
                        <div class="header-mobile--main-sub-menu-item-wrapper">
                            <p class="header-mobile--main-sub-menu-item-name">APIs</p>
                            <div class="header-mobile--main-sub-menu-item-icon">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     width="14"
                                     height="14"
                                     viewBox="0 0 14 14"
                                     class>
                                    <path d="M14 0v14H0z"></path>
                                </svg>
                            </div>
                        </div>
                        <ul class="header-mobile--main-sub-menu-item-children" sub-item-full-height="138">
                            <router-link :to="{ name: 'api-explorer-account-list' }"
                                         class="header-mobile--main-sub-menu-item-children-link">
                                <li class="header-mobile--main-sub-menu-item-children-node">
                                    <div class="header-mobile--main-sub-menu-item-children-icon">
                                        <img src="/images/icon-account-list.svg" width="18" height="18" alt>
                                    </div>
                                    <div class="header-mobile--main-sub-menu-item-children-name">Account list</div>
                                </li>
                            </router-link>
                            <router-link :to="{ name: 'api-explorer-accounts' }"
                                         class="header-mobile--main-sub-menu-item-children-link">
                                <li class="header-mobile--main-sub-menu-item-children-node">
                                    <div class="header-mobile--main-sub-menu-item-children-icon">
                                        <img src="/images/icon-accounts.svg" width="18" height="18" alt>
                                    </div>
                                    <div class="header-mobile--main-sub-menu-item-children-name">Accounts</div>
                                </li>
                            </router-link>
                            <router-link :to="{name: 'api-explorer-payments'}">
                                <li class="header-mobile--main-sub-menu-item-children-node">
                                    <div class="header-mobile--main-sub-menu-item-children-icon">
                                        <img src="/images/icon-payments.svg" width="18" height="18" alt>
                                    </div>
                                    <div class="header-mobile--main-sub-menu-item-children-name">Payments</div>
                                </li>
                            </router-link>
                        </ul>
                    </li>
                    <!-- Settings -->
                    <li v-bind:style=" !name ? 'display: none;' : '' "
                        class="header-mobile--main-sub-menu-item">
                        <div class="header-mobile--main-sub-menu-item-clickable-area"></div>
                        <div class="header-mobile--main-sub-menu-item-wrapper">
                            <p class="header-mobile--main-sub-menu-item-name">Settings</p>
                            <div class="header-mobile--main-sub-menu-item-icon">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     width="14"
                                     height="14"
                                     viewBox="0 0 14 14"
                                     class>
                                    <path d="M14 0v14H0z"></path>
                                </svg>
                            </div>
                        </div>
                        <ul class="header-mobile--main-sub-menu-item-children" sub-item-full-height="93">
                            <a href="/p/tpp-certificate" class="header-mobile--main-sub-menu-item-children-link">
                                <router-link :to="{name: 'tpp-certificate'}">
                                    <li class="header-mobile--main-sub-menu-item-children-node">
                                        <div class="header-mobile--main-sub-menu-item-children-icon">
                                            <img src="/images/icon-certificate.svg" width="18" height="18" alt>
                                        </div>
                                        <div class="header-mobile--main-sub-menu-item-children-name">Tpp certificate</div>
                                    </li>
                                </router-link>
                            </a>
                            <a href="/p/qseal-certificate" class="header-mobile--main-sub-menu-item-children-link">
                                <router-link :to="{name: 'qseal-certificate'}">
                                    <li class="header-mobile--main-sub-menu-item-children-node">
                                        <div class="header-mobile--main-sub-menu-item-children-icon">
                                            <img src="/images/icon-certificate-qseal.svg" width="18" height="18" alt>
                                        </div>
                                        <div class="header-mobile--main-sub-menu-item-children-name">QSEAL certificate</div>
                                    </li>
                                </router-link>
                            </a>
                        </ul>
                    </li>
                    <!--/. Settings -->
                    <a class="header-mobile--main-sub-menu-item-link"
                       href="https://urbo.lt/en/private/faq/daily-banking/e-banking"
                       target="_blank">
                    <li class="header-mobile--main-sub-menu-item">
                        <div class="header-mobile--main-sub-menu-item-wrapper">
                            <p class="header-mobile--main-sub-menu-item-name">FAQ</p>
                        </div>
                    </li>
                    </a>
                    <!--/. Privacy policy -->
                    <a class="header-mobile--main-sub-menu-item-link"
                       href="https://urbo.lt/en/privacy-policy"
                       target="_blank">
                    <li class="header-mobile--main-sub-menu-item">
                        <div class="header-mobile--main-sub-menu-item-wrapper">
                            <p class="header-mobile--main-sub-menu-item-name">Privacy policy</p>
                        </div>
                    </li>
                    </a>
                    <!--/. Cookies -->
                    <a class="header-mobile--main-sub-menu-item-link"
                       href="javascript: CookieScript.instance.show()">
                       
                    <li class="header-mobile--main-sub-menu-item">
                        <div class="header-mobile--main-sub-menu-item-wrapper">
                            <p class="header-mobile--main-sub-menu-item-name">Cookies</p>
                        </div>
                    </li>
                    </a>
                </ul>
            </div>
          </div>
        </div>
      </header>
      <div class="header-mobile--shade"></div>
    </div>
    <!--/. header -->
    <!-- content -->
    <router-view/>
    <!-- footer -->
    <footer class="footer">
      <div class="footer--content">
        <div class="footer--content-wrapper">
          <div class="footer--content-item">
            <p class="footer--content-item-name">Need help?</p>
            <div class="footer--content-contacts-menu-wrapper">
              <div class="contacts-menu">
                <ul class="contacts-menu--list">
                  <li class="contacts-menu--item">
                    <a class="contacts-menu--item-link" href="tel:+370 5 264 4800" target="_self">
                      <div class="contacts-menu--item-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          class
                        >
                          <path
                            transform="translate(-730 -1535)"
                            d="M739 1535a9 9 0 1 1 0 18.01 9 9 0 0 1 0-18.01zm0 16.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4zm3.73-5.32a.38.38 0 0 1 .26.34 1.6 1.6 0 0 1-.6 1.34l-.1.08-.05.04a.83.83 0 0 1-.07.06l-.07.04c-1.04.6-3-.1-4.72-1.7a7.92 7.92 0 0 1-.2-.2l-.04-.03-.04-.03-.2-.2c-1.59-1.72-2.28-3.69-1.69-4.72l.05-.08a.83.83 0 0 1 .05-.07l.04-.06.08-.1c.33-.4.83-.62 1.35-.58.09 0 .18.04.24.1l.09.15.13.38.5 1.47c.04.13.01.27-.08.37l-.43.5c-.1.1-.11.26-.05.38a4.99 4.99 0 0 0 2.45 2.47c.13.06.28.03.39-.06l.5-.44c.1-.09.24-.12.37-.07l1.47.5.37.13z"
                          ></path>
                        </svg>
                      </div>
                      <div class="contacts-menu--item-name">+370 5 264 4800</div>
                    </a>
                  </li>
                  <li class="contacts-menu--item">
                    <a
                      class="contacts-menu--item-link"
                      href="https://urbo.lt/en/contact-us"
                      target="_blank"
                    >
                      <div class="contacts-menu--item-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                        >
                          <path
                            transform="translate(-731 -21)"
                            d="M739.99 21a9 9 0 1 1 .01 18 9 9 0 0 1-.01-18zm.01 16.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4zm3.2-10.2c.44 0 .8.34.8.75v4.5c0 .41-.36.75-.8.75h-6.4c-.44 0-.8-.34-.8-.75v-4.5c0-.41.36-.75.8-.75zm0 1.5v-.75l-3.2 1.88-3.2-1.88v.75l3.2 1.88z"
                          ></path>
                        </svg>
                      </div>
                      <div class="contacts-menu--item-name">Contact us</div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="footer--content-item">
            <p class="footer--content-item-name">Information</p>
            <ul class="footer--content-menu">
                <li class="footer--content-menu-item">
                    <a class="footer--content-menu-item-link"
                       href="https://urbo.lt/en/private/faq/daily-banking/e-banking"
                       target="_blank">
                        <p class="footer--content-menu-item-name">FAQ</p>
                    </a>
                </li>
                <li class="footer--content-menu-item">
                    <a class="footer--content-menu-item-link"
                       href="https://urbo.lt/en/our-aspirations-and-values"
                       target="_blank">
                        <p class="footer--content-menu-item-name">About the bank</p>
                    </a>
                </li>
                <li class="footer--content-menu-item">
                    <a class="footer--content-menu-item-link"
                       href="https://urbo.lt/en/privacy-policy"
                       target="_blank">
                        <p class="footer--content-menu-item-name">Privacy policy</p>
                    </a>
                </li>

                <li class="footer--content-menu-item">
                    <a class="footer--content-menu-item-link"
                       href="javascript: CookieScript.instance.show()">
                        <p class="footer--content-menu-item-name">Cookies</p>
                    </a>
                </li>
            </ul>
          </div>
          <div class="footer--content-item">
            <p class="footer--content-item-name">Mobile Bank app on your phone</p>
            <p class="footer--content-item-caption">Download the Mobile bank app!</p>
            <div class="footer--content-item-download-block">
              <div class="footer--content-item-download-block-item">
                <a
                  class="footer--content-item-download-block-item-link"
                  href="https://play.google.com/store/apps/details?id=medbank.lt&amp;hl=lt"
                  target="_blank"
                >
                  <div>
                    <img src="/images/google-play.svg" width="auto" height="34" alt>
                  </div>
                </a>
              </div>
              <div class="footer--content-item-download-block-item">
                <a
                  class="footer--content-item-download-block-item-link"
                  href="https://itunes.apple.com/us/app/medicinos-banko-mobilioji/id588725823?mt=8"
                  target="_blank"
                >
                  <div>
                    <img src="/images/ios.svg" width="auto" height="34" alt>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer--credits">
        <div class="footer--credits-wrapper">
          <p class="footer--credits-text">All rights reserved © Urbo bankas {{ new Date().getFullYear() }}</p>
          <div class="footer--credits-social">
            <p class="footer--credits-social-text">Join us</p>
            <ul class="footer--credits-social-list">
              <li class="footer--credits-social-list-item">
                <a
                  class="footer--credits-social-list-item-link"
                  href="https://www.facebook.com/Medicinos.bankas/"
                  target="_blank"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                  >
                    <path
                      transform="translate(-1177 -2774)"
                      d="M1196.32 2801h-3.55v-8.5H1191v-2.93h1.77v-1.76c0-2.39 1-3.81 3.85-3.81h2.36v2.93h-1.48c-1.1 0-1.18.41-1.18 1.17v1.47h2.68l-.31 2.93h-2.37v8.5z"
                    ></path>
                  </svg>
                </a>
              </li>
              <li class="footer--credits-social-list-item">
                <a
                  class="footer--credits-social-list-item-link"
                  href="https://www.linkedin.com/company/medicinos-bankas/"
                  target="_blank"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    class
                  >
                    <path
                      transform="translate(-1226 -2774)"
                      d="M1236.4 2800h3.12v-10.87h-3.12zm1.48-12.23c1.18 0 1.9-.83 1.9-1.89-.02-1.07-.72-1.88-1.88-1.88-1.15 0-1.9.81-1.9 1.89a1.8 1.8 0 0 0 1.86 1.88zM1252 2800v-6.04c0-3.37-1.74-4.93-3.96-4.93-1.78 0-2.9 1.06-3.11 1.8v-1.7h-3.5c.04.9 0 10.87 0 10.87h3.5v-5.88c0-.33-.01-.66.08-.89.24-.65.75-1.33 1.68-1.33 1.22 0 1.77 1 1.77 2.47v5.63z"
                    ></path>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
    <!--/. footer -->
    <!-- start modal -->
    <div class="modal fade" id="myModal" role="dialog">
      <div class="modal-dialog modal-sm">
        <div class="modal-content" style="width: 340px;">
          <div class="modal-body">
            <div class="col-md-12 mx-auto">
              <button type="button" class="close" data-dismiss="modal">&times;</button>

              <!-- first tab -->
              <div id="first">
                <login/>
              </div>
              <!--/. first tab -->
              <div id="second">
                <sign-up/>
              </div>
              <!-- third tab -->
              <div id="third">
                <reset/>
              </div>
              <!--/. third tab -->
              <!-- fourth tab -->
              <div id="fourth">
                <new-password/>
              </div>
              <!--/. fourth tab -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.modal -->
  </div>
</template>
<script>
import { mapState } from "vuex";
var me;

export default {
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    loginWindow() {
      this.$store.dispatch("loginWindow");
    }
  },
  computed: {
    ...mapState({
      name: state => state.user.userInfo.name
    })
  },
  updated() {
    if (void 0 !== document.getElementsByClassName("contacts-menu---active")[0]) {
        var n = document.getElementsByClassName("content--block")[0];
        if (void 0 !== n) {
            n.classList.remove("content--block---contacts-open");
            n.classList.add("content--block---contacts-open");
        }
    }
  },
  mounted() {
    me = this;
    require("../public/js/script.js");

    if (typeof window.showPassword === "undefined") {
      window.showPassword = function(eye) {
        var field = eye.parentNode.parentNode.querySelector("input");

        if (field.getAttribute("type") === "password") {
          eye.classList.add("primary-input--password-eye---active");
          field.setAttribute("type", "text");
        } else {
          eye.classList.remove("primary-input--password-eye---active");
          field.setAttribute("type", "password");
        }
      };
    }

    $(".header--item-clickable-area").click(function() {
      $(".header--sub-menu-content-item.accountListClick").click(function(event) {
        event.preventDefault();
        me.$router.push({ name: "api-explorer-account-list" });
      });
      $(".header--sub-menu-content-item.accountsClick").click(function(event) {
        event.preventDefault();
        me.$router.push({ name: "api-explorer-accounts" });
      });
      $(".header--sub-menu-content-item.paymentsClick").click(function(event) {
        event.preventDefault();
        me.$router.push({ name: "api-explorer-payments" });
      });
      $(".header--sub-menu-content-item.tppClick").click(function(event) {
        event.preventDefault();
        me.$router.push({ name: "tpp-certificate" });
      });
      $(".header--sub-menu-content-item.qsealClick").click(function(event) {
        event.preventDefault();
        me.$router.push({ name: "qseal-certificate" });
      });
    });

    $("#backtologin").click(function() {
      $("#third").fadeOut("fast", function() {
        $("#first").fadeIn("fast");
      });
    });

    $("#signup").click(function() {
      $("#first").fadeOut("fast", function() {
        $("#second").fadeIn("fast");
      });
    });

    $("#signin").click(function() {
      $("#second").fadeOut("fast", function() {
        $("#first").fadeIn("fast");
      });
    });

    $("#forgotpsw").click(function() {
      $("#first").fadeOut("fast", function() {
        $("#third").fadeIn("fast");
      });
    });

    $(function() {
      $("form[name='login']").validate({
        rules: {
          email: {
            required: true,
            email: true
          },
          password: {
            required: true
          }
        },
        messages: {
          email: "Please enter a valid email address",

          password: {
            required: "Please enter password"
          }
        },
        submitHandler: function(form) {
          form.submit();
        }
      });
    });

    $(function() {
      $("form[name='registration']").validate({
        rules: {
          firstname: "required",
          lastname: "required",
          email: {
            required: true,
            email: true
          },
          password: {
            required: true,
            minlength: 5
          }
        },

        messages: {
          firstname: "Please enter your firstname",
          lastname: "Please enter your lastname",
          password: {
            required: "Please provide a password",
            minlength: "Your password must be at least 5 characters long"
          },
          email: "Please enter a valid email address"
        },

        submitHandler: function(form) {
          form.submit();
        }
      });
    });
  }
};
</script>
<style>
.close {
  z-index: 500;
}

.flash {
  z-index: 3000;
}

.modal-open {
  overflow: auto !important;
}

body {
  overflow-y: auto !important;
  padding-right: 0px !important;
}

html {
  overflow-y: auto !important;
}
</style>